import requester from "./requester";

// Fixed Dimensions API requests

/**
 * Get all enabled fixed dimensions
 * @returns {Promise} Array of enabled fixed dimensions
 */
const getAllEnabledFixedDimensions = () => {
  return requester.request.get("/fixed-dimension/all");
};

/**
 * Get all fixed dimensions including disabled ones (Admin only)
 * @returns {Promise} Array of all fixed dimensions
 */
const getAllFixedDimensionsIncludeDisabled = () => {
  return requester.request.get("/fixed-dimension/all-include-disabled");
};

/**
 * Get fixed dimension by ID
 * @param {number} id - Fixed dimension ID
 * @returns {Promise} Fixed dimension details
 */
const getFixedDimensionById = (id) => {
  return requester.request.get("/fixed-dimension/detail", {
    params: { id },
  });
};

/**
 * Create a new fixed dimension (Admin only)
 * @param {Object} data - Fixed dimension data
 * @returns {Promise} Created fixed dimension
 */
const createFixedDimension = (data) => {
  return requester.request.post("/fixed-dimension/create", data);
};

/**
 * Update an existing fixed dimension (Admin only)
 * @param {Object} data - Fixed dimension data to update
 * @returns {Promise} Updated fixed dimension
 */
const updateFixedDimension = (data) => {
  return requester.request.post("/fixed-dimension/update", data);
};

/**
 * Delete a fixed dimension (Admin only)
 * @param {number} id - Fixed dimension ID
 * @returns {Promise} Deletion response
 */
const deleteFixedDimension = (id) => {
  return requester.request.delete("/fixed-dimension/delete", {
    params: { id },
  });
};

/**
 * Toggle fixed dimension enabled status (Admin only)
 * @param {number} id - Fixed dimension ID
 * @returns {Promise} Updated fixed dimension status
 */
const toggleFixedDimensionStatus = (id) => {
  return requester.request.post("/fixed-dimension/toggle", null, {
    params: { id },
  });
};

/**
 * Get all available data source types
 * @returns {Promise} Array of data source types
 */
const getDataSourceTypes = () => {
  return requester.request.get("/fixed-dimension/data-sources");
};

/**
 * Get count of enabled fixed dimensions
 * @returns {Promise} Count of enabled fixed dimensions
 */
const getEnabledFixedDimensionsCount = () => {
  return requester.request.get("/fixed-dimension/count-enabled");
};

export default {
  getAllEnabledFixedDimensions,
  getAllFixedDimensionsIncludeDisabled,
  getFixedDimensionById,
  createFixedDimension,
  updateFixedDimension,
  deleteFixedDimension,
  toggleFixedDimensionStatus,
  getDataSourceTypes,
  getEnabledFixedDimensionsCount,
};